import { createAsyncThunk } from "@reduxjs/toolkit";
import { directoryAPI } from "libs/apiClient/Directory";

export const checkCompletingReferences = createAsyncThunk(
	"referencesSlice/checkCompletingReferences",
	async (_: undefined, { rejectWithValue }) => {
		try {
			return await directoryAPI.emptinessStatusList().then((r) => r.data);
			// return (await $api.get(`/directory/emptiness-status`)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);
